import React from 'react'
import { Tooltip } from '@homeviews/shared-ui'
import { formatRating } from '@homeviews/utils'
import { Box } from '@material-ui/core'

export const createDevelopmentScoresTableRows = (
  data: any,
  benchmarkData,
  additionalQuestionsBenchmarkData,
  headCells,
  typeFilter,
  developmentType,
) => {
  const rows = []

  if (!data || !data.length) {
    return {
      rows,
      benchmarkRow: [],
    }
  }
  data.forEach((dev: any) => {
    const rowData = [dev.id]
    let emptyDataCount = 1
    headCells.forEach((cell) => {
      const specificDmentType = dev?.development_type?.name
      if (typeFilter === 'btrAdditionalQuestions') {
        if (specificDmentType !== 'Build To Rent') {
          return false
        }
      } else if (typeFilter === 'btsAdditionalQuestions') {
        if (specificDmentType === 'Build To Rent') {
          return false
        }
      }
      if (dev?.[cell.id] === '0.00' || !dev?.[cell.id]) {
        emptyDataCount++
      }
      rowData.push(dev?.[cell.id] || '')
    })

    if (rowData.length > 1 && emptyDataCount < rowData.length - 1) {
      rows.push(rowData)
    }
  })

  let benchmarkRowData = []

  let benchmarkTooltip = ''

  if (benchmarkData) {
    benchmarkTooltip =
      'Discover the HomeViews UK benchmark. This is based on all time data up to the last full half year period.'

    if (developmentType === 'Build To Rent') {
      benchmarkTooltip =
        'Discover the HomeViews UK benchmark specific to Build to Rent. This is based on all time data up to the last full half year period.'
    } else if (developmentType === 'Build To Sell') {
      benchmarkTooltip =
        'Discover the HomeViews UK benchmark specific, based upon reviews in Build to Sell properties. This is based on all time data up to the last full half year period.'
    }

    benchmarkRowData = ['benchmark_row']
    headCells.forEach((cell) => {
      if (cell.id === 'name') {
        const benchmarkHead = (
          <Box display="flex">
            <span>HomeViews Benchmark Score</span>
            <Tooltip text={benchmarkTooltip} />
          </Box>
        )
        benchmarkRowData.push(benchmarkHead)
        return
      }
      benchmarkRowData.push(
        benchmarkData?.[cell.id] ? formatRating(benchmarkData[cell.id]) : '',
      )
    })
  }
  if (additionalQuestionsBenchmarkData) {
    benchmarkTooltip =
      typeFilter === 'btsAdditionalQuestions'
        ? 'Discover the HomeViews UK benchmark specific, based upon reviews in Build to Sell properties. This is based on all time data up to the last full half year period.'
        : 'Discover the HomeViews UK benchmark specific to Build to Rent. This is based on all time data up to the last full half year period.'
    benchmarkRowData = ['benchmark_row']
    headCells.forEach((cell) => {
      if (cell.id === 'name') {
        const benchmarkHead = (
          <Box display="flex">
            <span>HomeViews Benchmark Score</span>
            <Tooltip text={benchmarkTooltip} />
          </Box>
        )
        benchmarkRowData.push(benchmarkHead)
        return
      }

      const benchmarkValue =
        additionalQuestionsBenchmarkData?.['owner']?.[cell.id] ||
        additionalQuestionsBenchmarkData?.['owner']?.[cell.id2] ||
        additionalQuestionsBenchmarkData?.['tenant']?.[cell.id] ||
        additionalQuestionsBenchmarkData?.['tenant']?.[cell.id2] ||
        ''
      benchmarkRowData.push(benchmarkValue ? formatRating(benchmarkValue) : '')
    })
  }

  return {
    rows,
    benchmarkRow: benchmarkRowData,
  }
}
